const {initFilter, getDefaultFilterParams, IntervalFilterAdmin} = require("../../../dumb/IntervalFilterCustom");
const withReDelay = require("mn-utils/withReDelay");
const LayoutA = require("../../../dumb/Layout/A");
const HeaderA = require("../../../dumb/Header/A");
const CaptionA = require("../../../dumb/Caption/A");
const ButtonD = require("../../../dumb/Button/D");
const {default: RefreshIcon} = require("@material-ui/icons/Refresh");
const ReportDownload = require("../../../dumb/ReportDownload/AdminRD");
const RowB = require("../../../dumb/Row/B");
const ColB2 = require("../../../dumb/Col/B2");
const ColB = require("../../../dumb/Col/B");
const TableItem = require("./components/TableItem");
const ButtonUp = require("../../../dumb/Button/Up");
const React = require("react");
const {apiAdminKlubcoinFeesList} = require("../../../../api/admin/klubcoinFeesList");

const filter$ = initFilter();

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
  },
  rowHeight: 70,
  request: apiAdminKlubcoinFeesList,
  getParams: getDefaultFilterParams,
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <LayoutA>
          <div className="layoutRow jcSB aiC">
            <HeaderA>
              <CaptionA>Promo Fees</CaptionA>
            </HeaderA>
            <div className="layoutRow aiC">
              <ButtonD
                className="wmin100"
                onClick={self.update}
              >
                <RefreshIcon/>
                <div className="pl15">Refresh</div>
              </ButtonD>
              {!noData && (
                <ReportDownload
                  className="pl10"
                  urlPrefix="/v1/admin/report-tx/"
                  filter={getDefaultFilterParams(self, {disableDateConversion: true})}
                  disablePrint
                />
              )}
            </div>
          </div>
          <IntervalFilterAdmin
            className="mt16"
            data={filter}
            onChange={handleChangeFilter}
            hideSearch
            // search={{
            //   className: 'w330',
            //   placeholder: 'Search by ID',
            // }}
          />
          <div className="rlv h100vh-380 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1150 rlv h">
                <div>
                  <RowB className="f14">
                    <ColB className="wmin155 fx1">ID</ColB>
                    <ColB className="wmin100 fx1">Amount</ColB>
                    <ColB className="wmin100 fx1">Fee</ColB>
                    <ColB className="wmin110">Trx Count</ColB>
                    <ColB className="wmin95">Date</ColB>
                    <ColB className="wmin100 fx1">Status</ColB>
                    <ColB2 className="w56"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(TableItem)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
